import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import disImg from "../../../Images/Discover/banner-v3.webp";
import disShape from "../../../Images/Discover/video1.png";
import "./Discover.css";
const Discover = () => {
  return (
    <section className="discover overflow-hidden">
      <Row className="align-items-center">
        <Col md={6} xs={12} sm={12}>
          <div className="discover-content">
            <h1>A new look New style for you!</h1>
            <p>
              To succeed you must believe. When you believe, you will succeed. I
              told you all this before, when you have a swimming pool, do not
              use chlorine, use salt water, the healing. To succeed you must
              believe. When you believe, you will succeed.
            </p>
            <Link to="/watches">
              <button className="offer-btn">Discover More</button>
            </Link>
          </div>
        </Col>
        <Col md={6} xs={12} sm={12}>
          <div className="discover-right">
            <img className="disImage w-100" src={disImg} alt="" />
            <img className="disShape" src={disShape} alt="" />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Discover;
